export default "__VITE_ASSET__D0$BK4HN__"